import {
    CARD_PRODUCT_COMPARISON,
    INITIAL_DATA_FILTER,
    SORT_PRODUCT,
    TABLE_PRODUCT,
} from 'configs/analytics/configTableProduct'
import DateRangePicker from 'components/commons/date-range-picker'
import moment from 'moment'
import icLinkExternal from 'assets/images/ic-link-external.svg'
import { Button } from 'avo-ui'
import CardComparison from 'components/commons/card-comparison'
import TabToggle from 'components/commons/tab-toogle'
import Graph from 'components/commons/graph'
import Search from 'components/commons/search'
import PageLimit from 'components/commons/page-limit'
import Table from 'components/commons/table'
import ModalExport from 'components/commons/modal-export'
import Sort from 'components/commons/sort'
import { AdvanceFilterContainer } from '../../../containers/analytics/product/AdvanceFilterContainer'
import { useRef } from 'react'

export const Product = ({
    dataComparison,
    dataGraph,
    dataList,
    query,
    onChangeQuery,
    queryFilter,
    onFilter,
    modal,
    setShowModal,
    onSelectSort,
    isLoadingComparison,
    isLoadingGraph,
    isLoadingList,
    isLoadingExport,
    onExport,
}) => {
    const listRef = useRef()
    const initDate = [INITIAL_DATA_FILTER?.start_date, INITIAL_DATA_FILTER?.end_date]

    const onChangePage = (value) => {
        listRef.current?.scrollIntoView()
        onChangeQuery(value)
    }

    return (
        <div className={'flex flex-col gap-y-5 px-9 py-5'}>
            <div className={'flex space-x-3'}>
                <DateRangePicker
                    value={query?.start_date ? [query?.start_date, query?.end_date] : initDate}
                    onChange={(value) =>
                        onChangeQuery({
                            ...INITIAL_DATA_FILTER,
                            start_date: value[0] || initDate[0],
                            end_date: value[1] || initDate[1],
                        })
                    }
                    maxDate={moment()}
                    format={'YYYY-MM-DD'}
                />
                <AdvanceFilterContainer
                    show={modal?.filter}
                    setShow={(value) => setShowModal({ filter: value })}
                    values={queryFilter}
                    onSubmit={(value) => onFilter(value)}
                />
                <Button
                    title={'Export'}
                    icon={icLinkExternal}
                    type={'outline'}
                    disabled={!dataList?.total_result}
                    onClick={() => setShowModal({ export: true })}
                />
            </div>
            <TabToggle
                title={'Product & Comparison'}
                isLoading={isLoadingComparison}
                content={
                    <div className={'grid grid-cols-2 gap-4'}>
                        {CARD_PRODUCT_COMPARISON?.map((item) => (
                            <CardComparison
                                key={item?.name}
                                title={item?.title}
                                name={item?.name}
                                isCurrency={item?.isCurrency}
                                dataComparison={dataComparison}
                            />
                        ))}
                    </div>
                }
            />
            <TabToggle
                title={'Product Sold Graph'}
                isLoading={isLoadingGraph}
                content={<Graph title={'Jumlah Produk Terjual'} name={'product'} values={dataGraph || {}} />}
            />
            <TabToggle
                title={'Product Sold List'}
                content={
                    <div ref={listRef} className={'overflow-auto'}>
                        <div className={'flex space-x-3'}>
                            <Search value={query?.search} onSearch={(key) => onChangeQuery({ search: key, page: 1 })} />
                            <PageLimit
                                value={query?.limit}
                                onSelect={(value) => onChangeQuery({ limit: value, page: 1 })}
                            />
                            <Sort
                                options={SORT_PRODUCT}
                                value={`${query?.order_by}-${query?.order_type}`}
                                onSelect={(value) => onSelectSort(value)}
                            />
                        </div>
                        <div>
                            <Table
                                className={'my-3'}
                                name={TABLE_PRODUCT.name}
                                columns={TABLE_PRODUCT.column}
                                data={dataList?.result}
                                size={query?.limit}
                                currentPage={query?.page}
                                totalPage={dataList?.total_page}
                                totalResult={dataList?.total_result}
                                onChangePage={(val) => onChangePage({ page: val })}
                                loading={isLoadingList}
                            />
                        </div>
                    </div>
                }
            />
            {modal?.export && (
                <ModalExport
                    show={modal?.export}
                    onHide={() => setShowModal({ export: false })}
                    description={'Are You Sure Export This?'}
                    totalData={dataList?.total_result}
                    isLoading={isLoadingExport}
                    onExport={onExport}
                />
            )}
        </div>
    )
}
